import { zhSite } from './localized/zh'
import { enSite } from './localized/en'

export const localizedSite = {
  zh: zhSite,
  en: enSite
}

export function getLangFromPath(path) {
  return path && path.startsWith('/en') ? 'en' : 'zh'
}

export function getRoutePath(lang, key) {
  const routeMap = {
    zh: {
      home: '/index',
      product: '/product',
      about: '/about',
      contact: '/contact'
    },
    en: {
      home: '/en',
      product: '/en/product',
      about: '/en/about',
      contact: '/en/contact'
    }
  }
  return routeMap[lang][key] || routeMap[lang].home
}
